// 261010 UI1c — MỘT video = MỘT dòng tóm tắt (bấm để mở rộng tại chỗ ra nội dung đầy đủ như trước UI1c). Plan nhiều video: cả bước chỉ còn ~50 px / video khi thu.
import React from 'react';
import type { WorkflowStepKey, WorkflowStepState } from '../../types/filmWorkflow';
import type { RowSummary } from './workflowManyUtils';
import { STATE_META } from './workflowBoardUtils';
import type { StateTone } from './workflowBoardUtils';
import StatusIcon, { IconChip } from './StatusIcon';
import WfIcon from './WfIcon';
import WfIconButton from './WfIconButton';
import { flagChipOf, metaChipOf } from './workflowStatusIcons';
import { thumbKeysOf } from './workflowThumbsUtils';

interface Props {
  order: number;
  step: WorkflowStepKey;
  state: WorkflowStepState;
  /** Chip trạng thái (bước cấp plan: chữ của ô bước). */
  chip: { text: string; tone: string };
  summary: RowSummary;
  open: boolean;
  onToggle: () => void;
  onOpenDrawer: () => void;
  children: React.ReactNode;
}

const WorkflowVideoRow: React.FC<Props> = ({ order, step, state, chip, summary, open, onToggle, onOpenDrawer, children }) => (
  <article className={`wf-vrow wf-vrow1${open ? ' open' : ''} ${state === 'ERROR' ? 'bad' : state === 'STALE' ? 'warn' : state === 'NOT_READY' ? 'miss' : ''}`} data-testid={`wf-vrow-${order}`}>
    <header>
      <button type="button" className="wf-vrow-tg" aria-expanded={open} aria-label={`${open ? 'Thu' : 'Mở'} Video ${order}`} onClick={onToggle} data-testid={`wf-vrow-tg-${order}`}>
        <span className="chev" aria-hidden="true"><WfIcon name={open ? 'down' : 'right'} /></span>
        <b className="no">Video {order}</b>
        <StatusIcon text={chip.text} tone={(chip.tone || STATE_META[state].tone) as StateTone} focusable={false} />
        <span className="hl" title={summary.headline}>{summary.headline}</span>
        {summary.meta.map((m, i) => { const c = metaChipOf(m, step); return c
          ? <IconChip key={i} icon={c.icon} label={c.label} value={c.value} tone="meta" className="mt" focusable={false} />
          : <span key={i} className="mt mono">{m}</span>; })}
        {summary.thumbs.length ? <span className="th" aria-hidden="true">{(() => { const ks = thumbKeysOf(step, summary.thumbs); return summary.thumbs.map((u, i) => <img key={ks[i]} src={u} alt="" loading="lazy" />); })()}</span> : null}
        {summary.flags.map((f, i) => { const c = flagChipOf(f); return c
          ? <IconChip key={i} icon={c.icon} label={c.label} value={c.value} tone={c.tone ?? 'warn'} className="fl" focusable={false} />
          : <IconChip key={i} icon="warning" label={f} tone="warn" className="fl" focusable={false} />; })}{/* UI-errbox: cờ lạ cũng chỉ là biểu tượng + Tooltip, không chip chữ */}
        {(summary.kept ?? []).map((f, i) => <IconChip key={`k${i}`} icon="edit" label={`Bản sửa tay — máy giữ nguyên, không ghi đè: ${f}`} tone="meta" className="fl" testId="wf-kept" focusable={false} />)}
      </button>
      <WfIconButton icon="edit" label="Sửa / Chi tiết" onClick={onOpenDrawer} testId={`wf-vrow-open-${order}-${step}`} />
    </header>
    {open ? <div className="wf-vrow-b">{children}</div> : null}
  </article>
);

export default WorkflowVideoRow;
